import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@locales'

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'es',
    fallbackLocale: 'es',
    dateTimeFormats: {},
    numberFormats: {},
    silentTranslationWarn: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test',
    formatFallbackMessages: true,
    messages,
});

export default i18n